
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import AttachmentsView from "@/components/AttachmentsView/index.vue";
  import {AttachmentHostType, ReimbursementDto} from "@/api/appService";
  import api from '@/api/index';

  @Component({
    name: "reimbursement-detail",
    components:{
      AttachmentsView
    }
  })
  export default class ReimbursementDetail extends Vue {
    @Prop() detail?: ReimbursementDto;
    @Prop({ required: false, default: "rtl" }) direction!: string;
    @Prop()dataId?:number;

    detailData:ReimbursementDto = {};


    loading = false;

    show = false;

    get hostType(){
      return AttachmentHostType.Reimbursement;
    }

    private handleClose() {
      this.show = false;
    }

    @Watch('detail')
    onDetailChange(newValue:ReimbursementDto){
      this.detailData = newValue;
    }

    @Watch('show')
    onShowChange(value:boolean){
      if(!value)
        return;

      if(this.detail){
        return;
      }

      if(!this.dataId){
        return;
      }

    }

    @Watch('dataId')
    onDataIdChange(newId?:number){
      if(!newId){
        this.detailData = {};
        return
      }
      this.loading = true;
      api.reimbursement.get({id:newId}).then(res=>{
        this.detailData = res;
        this.loading = false;
      })
    }


  }
